// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { NamedFragmentDoc } from '../../../fragments/commonFragments.generated';
import { BidPlanGroupFieldsFragmentDoc } from '../plan-based-bid-package/PlanBasedBidPackagePage.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type AddBidPackagePage_OriginatingProjectQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type AddBidPackagePage_OriginatingProjectQuery = { __typename?: 'Query', project:
    | { __typename?: 'StandaloneProject', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } }
    | { __typename?: 'Region', id: string, name: string, market?: { __typename?: 'Market', id: string, name: string } | null | undefined }
    | { __typename?: 'Market', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } }
    | { __typename?: 'Community', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } }
    | { __typename?: 'Subdivision', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } }
    | { __typename?: 'Lot', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } }
    | { __typename?: 'Structure', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } }
    | { __typename?: 'Unit', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } }
   };

export type AddBidPackagePageQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type AddBidPackagePageQuery = { __typename?: 'Query', bidPackageGroup: { __typename?: 'BidPackageGroup', id: string, bidPackages: Array<{ __typename?: 'BidPackage', id: string, internalEstimateBidContract?: { __typename?: 'BidContract', id: string, archivedAt?: Types.Scalars['DateTime']['input'] | null | undefined } | null | undefined, bidPackageGroup?: { __typename?: 'BidPackageGroup', id: string } | null | undefined, costCodes: Array<{ __typename?: 'CostCode', id: string, name: string }>, projects: Array<
        | { __typename?: 'StandaloneProject', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } }
        | { __typename?: 'Region', id: string, name: string, market?: { __typename?: 'Market', id: string, name: string } | null | undefined }
        | { __typename?: 'Market', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } }
        | { __typename?: 'Community', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } }
        | { __typename?: 'Subdivision', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } }
        | { __typename?: 'Lot', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } }
        | { __typename?: 'Structure', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } }
        | { __typename?: 'Unit', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } }
      >, productOfferings: Array<{ __typename?: 'ProductOffering', id: string, name: string }>, requests: Array<{ __typename?: 'BidPackageRequest', id: string, tradePartner: { __typename?: 'TradePartner', id: string, name: string }, primaryContact?: { __typename?: 'TradePartnerContact', id: string, name: string } | null | undefined, secondaryContact?: { __typename?: 'TradePartnerContact', id: string, name: string } | null | undefined }>, costType: { __typename?: 'CostTypeDetail', code: Types.CostType, name: string }, lineItems: Array<{ __typename?: 'BidPackageLineItem', id: string, bidItem: { __typename?: 'BidItem', id: string } }>, bidPlanGroups: Array<{ __typename?: 'BidPlanGroup', id: string, order: number, isNoCost: boolean, globalOption?: { __typename?: 'GlobalOption', id: string } | null | undefined, primaryOptionGroup?: { __typename?: 'GlobalOptionGroup', id: string } | null | undefined, dimensions: Array<{ __typename?: 'BidPlanGroupDimension', id: string, globalOptionType?: { __typename?: 'GlobalOptionType', id: string } | null | undefined, globalOptionGroup?: { __typename?: 'GlobalOptionGroup', id: string } | null | undefined, globalOptions: Array<{ __typename?: 'GlobalOption', id: string }> }> }> }> } };

export type OverlappingBidPackagesQueryVariables = Types.Exact<{
  costCodes: Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input'];
  costType: Types.CostType;
  projects: Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input'];
}>;


export type OverlappingBidPackagesQuery = { __typename?: 'Query', overlappingBidPackages: { __typename?: 'OverlappingBidPackagesResult', bidPackages: Array<{ __typename?: 'BidPackage', id: string, name: string, projects: Array<
        | { __typename?: 'StandaloneProject', id: string, name: string }
        | { __typename?: 'Region', id: string, name: string }
        | { __typename?: 'Market', id: string, name: string }
        | { __typename?: 'Community', id: string, name: string }
        | { __typename?: 'Subdivision', id: string, name: string }
        | { __typename?: 'Lot', id: string, name: string }
        | { __typename?: 'Structure', id: string, name: string }
        | { __typename?: 'Unit', id: string, name: string }
      > }> } };

export type SaveBidPackagesMutationVariables = Types.Exact<{
  input: Array<Types.SaveBidPackageInput> | Types.SaveBidPackageInput;
}>;


export type SaveBidPackagesMutation = { __typename?: 'Mutation', saveBidPackages: { __typename?: 'SaveBidPackagesResult', bidPackages: Array<{ __typename?: 'BidPackage', id: string, internalEstimateBidContract?: { __typename?: 'BidContract', id: string, archivedAt?: Types.Scalars['DateTime']['input'] | null | undefined } | null | undefined, bidPackageGroup?: { __typename?: 'BidPackageGroup', id: string } | null | undefined, costCodes: Array<{ __typename?: 'CostCode', id: string, name: string }>, projects: Array<
        | { __typename?: 'StandaloneProject', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } }
        | { __typename?: 'Region', id: string, name: string, market?: { __typename?: 'Market', id: string, name: string } | null | undefined }
        | { __typename?: 'Market', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } }
        | { __typename?: 'Community', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } }
        | { __typename?: 'Subdivision', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } }
        | { __typename?: 'Lot', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } }
        | { __typename?: 'Structure', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } }
        | { __typename?: 'Unit', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } }
      >, productOfferings: Array<{ __typename?: 'ProductOffering', id: string, name: string }>, requests: Array<{ __typename?: 'BidPackageRequest', id: string, tradePartner: { __typename?: 'TradePartner', id: string, name: string }, primaryContact?: { __typename?: 'TradePartnerContact', id: string, name: string } | null | undefined, secondaryContact?: { __typename?: 'TradePartnerContact', id: string, name: string } | null | undefined }>, costType: { __typename?: 'CostTypeDetail', code: Types.CostType, name: string }, lineItems: Array<{ __typename?: 'BidPackageLineItem', id: string, bidItem: { __typename?: 'BidItem', id: string } }>, bidPlanGroups: Array<{ __typename?: 'BidPlanGroup', id: string, order: number, isNoCost: boolean, globalOption?: { __typename?: 'GlobalOption', id: string } | null | undefined, primaryOptionGroup?: { __typename?: 'GlobalOptionGroup', id: string } | null | undefined, dimensions: Array<{ __typename?: 'BidPlanGroupDimension', id: string, globalOptionType?: { __typename?: 'GlobalOptionType', id: string } | null | undefined, globalOptionGroup?: { __typename?: 'GlobalOptionGroup', id: string } | null | undefined, globalOptions: Array<{ __typename?: 'GlobalOption', id: string }> }> }> }> } };

export type AddBidPackagePage_OriginatingProject_StandaloneProject_Fragment = { __typename?: 'StandaloneProject', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } };

export type AddBidPackagePage_OriginatingProject_Region_Fragment = { __typename?: 'Region', id: string, name: string, market?: { __typename?: 'Market', id: string, name: string } | null | undefined };

export type AddBidPackagePage_OriginatingProject_Market_Fragment = { __typename?: 'Market', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } };

export type AddBidPackagePage_OriginatingProject_Community_Fragment = { __typename?: 'Community', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } };

export type AddBidPackagePage_OriginatingProject_Subdivision_Fragment = { __typename?: 'Subdivision', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } };

export type AddBidPackagePage_OriginatingProject_Lot_Fragment = { __typename?: 'Lot', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } };

export type AddBidPackagePage_OriginatingProject_Structure_Fragment = { __typename?: 'Structure', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } };

export type AddBidPackagePage_OriginatingProject_Unit_Fragment = { __typename?: 'Unit', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } };

export type AddBidPackagePage_OriginatingProjectFragment =
  | AddBidPackagePage_OriginatingProject_StandaloneProject_Fragment
  | AddBidPackagePage_OriginatingProject_Region_Fragment
  | AddBidPackagePage_OriginatingProject_Market_Fragment
  | AddBidPackagePage_OriginatingProject_Community_Fragment
  | AddBidPackagePage_OriginatingProject_Subdivision_Fragment
  | AddBidPackagePage_OriginatingProject_Lot_Fragment
  | AddBidPackagePage_OriginatingProject_Structure_Fragment
  | AddBidPackagePage_OriginatingProject_Unit_Fragment
;

export type AddBidPackagePage_BidPackagesFragment = { __typename?: 'BidPackage', id: string, internalEstimateBidContract?: { __typename?: 'BidContract', id: string, archivedAt?: Types.Scalars['DateTime']['input'] | null | undefined } | null | undefined, bidPackageGroup?: { __typename?: 'BidPackageGroup', id: string } | null | undefined, costCodes: Array<{ __typename?: 'CostCode', id: string, name: string }>, projects: Array<
    | { __typename?: 'StandaloneProject', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } }
    | { __typename?: 'Region', id: string, name: string, market?: { __typename?: 'Market', id: string, name: string } | null | undefined }
    | { __typename?: 'Market', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } }
    | { __typename?: 'Community', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } }
    | { __typename?: 'Subdivision', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } }
    | { __typename?: 'Lot', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } }
    | { __typename?: 'Structure', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } }
    | { __typename?: 'Unit', id: string, name: string, market: { __typename?: 'Market', id: string, name: string } }
  >, productOfferings: Array<{ __typename?: 'ProductOffering', id: string, name: string }>, requests: Array<{ __typename?: 'BidPackageRequest', id: string, tradePartner: { __typename?: 'TradePartner', id: string, name: string }, primaryContact?: { __typename?: 'TradePartnerContact', id: string, name: string } | null | undefined, secondaryContact?: { __typename?: 'TradePartnerContact', id: string, name: string } | null | undefined }>, costType: { __typename?: 'CostTypeDetail', code: Types.CostType, name: string }, lineItems: Array<{ __typename?: 'BidPackageLineItem', id: string, bidItem: { __typename?: 'BidItem', id: string } }>, bidPlanGroups: Array<{ __typename?: 'BidPlanGroup', id: string, order: number, isNoCost: boolean, globalOption?: { __typename?: 'GlobalOption', id: string } | null | undefined, primaryOptionGroup?: { __typename?: 'GlobalOptionGroup', id: string } | null | undefined, dimensions: Array<{ __typename?: 'BidPlanGroupDimension', id: string, globalOptionType?: { __typename?: 'GlobalOptionType', id: string } | null | undefined, globalOptionGroup?: { __typename?: 'GlobalOptionGroup', id: string } | null | undefined, globalOptions: Array<{ __typename?: 'GlobalOption', id: string }> }> }> };

export const AddBidPackagePage_OriginatingProjectFragmentDoc = gql`
    fragment AddBidPackagePage_OriginatingProject on Project {
  ...Named
  market {
    ...Named
  }
}
    ${NamedFragmentDoc}`;
export const AddBidPackagePage_BidPackagesFragmentDoc = gql`
    fragment AddBidPackagePage_BidPackages on BidPackage {
  id
  internalEstimateBidContract {
    id
    archivedAt
  }
  bidPackageGroup {
    id
  }
  costCodes {
    ...Named
  }
  projects {
    ...Named
    market {
      ...Named
    }
  }
  productOfferings {
    id
    name
  }
  requests {
    id
    tradePartner {
      ...Named
    }
    primaryContact {
      ...Named
    }
    secondaryContact {
      ...Named
    }
  }
  costType {
    code
    name
  }
  lineItems {
    id
    bidItem {
      id
    }
  }
  bidPlanGroups {
    ...BidPlanGroupFields
  }
}
    ${NamedFragmentDoc}
${BidPlanGroupFieldsFragmentDoc}`;
export const AddBidPackagePage_OriginatingProjectDocument = gql`
    query AddBidPackagePage_OriginatingProject($id: ID!) {
  project(id: $id) {
    ...AddBidPackagePage_OriginatingProject
  }
}
    ${AddBidPackagePage_OriginatingProjectFragmentDoc}`;

/**
 * __useAddBidPackagePage_OriginatingProjectQuery__
 *
 * To run a query within a React component, call `useAddBidPackagePage_OriginatingProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddBidPackagePage_OriginatingProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddBidPackagePage_OriginatingProjectQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAddBidPackagePage_OriginatingProjectQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AddBidPackagePage_OriginatingProjectQuery, AddBidPackagePage_OriginatingProjectQueryVariables> & ({ variables: AddBidPackagePage_OriginatingProjectQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AddBidPackagePage_OriginatingProjectQuery, AddBidPackagePage_OriginatingProjectQueryVariables>(AddBidPackagePage_OriginatingProjectDocument, options);
      }
export function useAddBidPackagePage_OriginatingProjectLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AddBidPackagePage_OriginatingProjectQuery, AddBidPackagePage_OriginatingProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AddBidPackagePage_OriginatingProjectQuery, AddBidPackagePage_OriginatingProjectQueryVariables>(AddBidPackagePage_OriginatingProjectDocument, options);
        }
// @ts-ignore
export function useAddBidPackagePage_OriginatingProjectSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AddBidPackagePage_OriginatingProjectQuery, AddBidPackagePage_OriginatingProjectQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AddBidPackagePage_OriginatingProjectQuery, AddBidPackagePage_OriginatingProjectQueryVariables>;
export function useAddBidPackagePage_OriginatingProjectSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AddBidPackagePage_OriginatingProjectQuery, AddBidPackagePage_OriginatingProjectQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AddBidPackagePage_OriginatingProjectQuery | undefined, AddBidPackagePage_OriginatingProjectQueryVariables>;
export function useAddBidPackagePage_OriginatingProjectSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AddBidPackagePage_OriginatingProjectQuery, AddBidPackagePage_OriginatingProjectQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AddBidPackagePage_OriginatingProjectQuery, AddBidPackagePage_OriginatingProjectQueryVariables>(AddBidPackagePage_OriginatingProjectDocument, options);
        }
export type AddBidPackagePage_OriginatingProjectQueryHookResult = ReturnType<typeof useAddBidPackagePage_OriginatingProjectQuery>;
export type AddBidPackagePage_OriginatingProjectLazyQueryHookResult = ReturnType<typeof useAddBidPackagePage_OriginatingProjectLazyQuery>;
export type AddBidPackagePage_OriginatingProjectSuspenseQueryHookResult = ReturnType<typeof useAddBidPackagePage_OriginatingProjectSuspenseQuery>;
export type AddBidPackagePage_OriginatingProjectQueryResult = ApolloReactCommon.QueryResult<AddBidPackagePage_OriginatingProjectQuery, AddBidPackagePage_OriginatingProjectQueryVariables>;
export const AddBidPackagePageDocument = gql`
    query AddBidPackagePage($id: ID!) {
  bidPackageGroup(id: $id) {
    id
    bidPackages {
      ...AddBidPackagePage_BidPackages
    }
  }
}
    ${AddBidPackagePage_BidPackagesFragmentDoc}`;

/**
 * __useAddBidPackagePageQuery__
 *
 * To run a query within a React component, call `useAddBidPackagePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddBidPackagePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddBidPackagePageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAddBidPackagePageQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AddBidPackagePageQuery, AddBidPackagePageQueryVariables> & ({ variables: AddBidPackagePageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AddBidPackagePageQuery, AddBidPackagePageQueryVariables>(AddBidPackagePageDocument, options);
      }
export function useAddBidPackagePageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AddBidPackagePageQuery, AddBidPackagePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AddBidPackagePageQuery, AddBidPackagePageQueryVariables>(AddBidPackagePageDocument, options);
        }
// @ts-ignore
export function useAddBidPackagePageSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AddBidPackagePageQuery, AddBidPackagePageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AddBidPackagePageQuery, AddBidPackagePageQueryVariables>;
export function useAddBidPackagePageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AddBidPackagePageQuery, AddBidPackagePageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AddBidPackagePageQuery | undefined, AddBidPackagePageQueryVariables>;
export function useAddBidPackagePageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AddBidPackagePageQuery, AddBidPackagePageQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AddBidPackagePageQuery, AddBidPackagePageQueryVariables>(AddBidPackagePageDocument, options);
        }
export type AddBidPackagePageQueryHookResult = ReturnType<typeof useAddBidPackagePageQuery>;
export type AddBidPackagePageLazyQueryHookResult = ReturnType<typeof useAddBidPackagePageLazyQuery>;
export type AddBidPackagePageSuspenseQueryHookResult = ReturnType<typeof useAddBidPackagePageSuspenseQuery>;
export type AddBidPackagePageQueryResult = ApolloReactCommon.QueryResult<AddBidPackagePageQuery, AddBidPackagePageQueryVariables>;
export const OverlappingBidPackagesDocument = gql`
    query OverlappingBidPackages($costCodes: [ID!]!, $costType: CostType!, $projects: [ID!]!) {
  overlappingBidPackages(
    costCodes: $costCodes
    costType: $costType
    projects: $projects
  ) {
    bidPackages {
      id
      name
      projects {
        ...Named
      }
    }
  }
}
    ${NamedFragmentDoc}`;

/**
 * __useOverlappingBidPackagesQuery__
 *
 * To run a query within a React component, call `useOverlappingBidPackagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOverlappingBidPackagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOverlappingBidPackagesQuery({
 *   variables: {
 *      costCodes: // value for 'costCodes'
 *      costType: // value for 'costType'
 *      projects: // value for 'projects'
 *   },
 * });
 */
export function useOverlappingBidPackagesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OverlappingBidPackagesQuery, OverlappingBidPackagesQueryVariables> & ({ variables: OverlappingBidPackagesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OverlappingBidPackagesQuery, OverlappingBidPackagesQueryVariables>(OverlappingBidPackagesDocument, options);
      }
export function useOverlappingBidPackagesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OverlappingBidPackagesQuery, OverlappingBidPackagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OverlappingBidPackagesQuery, OverlappingBidPackagesQueryVariables>(OverlappingBidPackagesDocument, options);
        }
// @ts-ignore
export function useOverlappingBidPackagesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OverlappingBidPackagesQuery, OverlappingBidPackagesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OverlappingBidPackagesQuery, OverlappingBidPackagesQueryVariables>;
export function useOverlappingBidPackagesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OverlappingBidPackagesQuery, OverlappingBidPackagesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OverlappingBidPackagesQuery | undefined, OverlappingBidPackagesQueryVariables>;
export function useOverlappingBidPackagesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OverlappingBidPackagesQuery, OverlappingBidPackagesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OverlappingBidPackagesQuery, OverlappingBidPackagesQueryVariables>(OverlappingBidPackagesDocument, options);
        }
export type OverlappingBidPackagesQueryHookResult = ReturnType<typeof useOverlappingBidPackagesQuery>;
export type OverlappingBidPackagesLazyQueryHookResult = ReturnType<typeof useOverlappingBidPackagesLazyQuery>;
export type OverlappingBidPackagesSuspenseQueryHookResult = ReturnType<typeof useOverlappingBidPackagesSuspenseQuery>;
export type OverlappingBidPackagesQueryResult = ApolloReactCommon.QueryResult<OverlappingBidPackagesQuery, OverlappingBidPackagesQueryVariables>;
export const SaveBidPackagesDocument = gql`
    mutation SaveBidPackages($input: [SaveBidPackageInput!]!) {
  saveBidPackages(input: $input) {
    bidPackages {
      ...AddBidPackagePage_BidPackages
    }
  }
}
    ${AddBidPackagePage_BidPackagesFragmentDoc}`;

/**
 * __useSaveBidPackagesMutation__
 *
 * To run a mutation, you first call `useSaveBidPackagesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveBidPackagesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveBidPackagesMutation, { data, loading, error }] = useSaveBidPackagesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveBidPackagesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveBidPackagesMutation, SaveBidPackagesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveBidPackagesMutation, SaveBidPackagesMutationVariables>(SaveBidPackagesDocument, options);
      }
export type SaveBidPackagesMutationHookResult = ReturnType<typeof useSaveBidPackagesMutation>;
export type SaveBidPackagesMutationResult = ApolloReactCommon.MutationResult<SaveBidPackagesMutation>;